// extracted by mini-css-extract-plugin
module.exports = {"comments-count":"metype-m__comments-count__39p2Q","hide-comment":"metype-m__hide-comment__3-onP"};